exports["ISO-2022-JP"] = require('./charset-recog-2022jp');

exports["ISO-2022-KR"] = require('./charset-recog-2022kr');

exports["ISO-2022-CN"] = require('./charset-recog-2022cn');


//////////////////
// WEBPACK FOOTER
// ./node_modules/charset-detector/src/2022/index.js
// module id = 1825
// module chunks = 0